// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2b_NR","content":"styles_content__W-rSz","selectAll":"styles_selectAll__zmeUE"};